// export const ENDPOINT = "http://216.219.84.38:8686/api/";
// export const WEB_URL = "http://216.219.84.38:6565/";

// export const ENDPOINT = "http://69.169.101.31:5031/api/";
// export const WEB_URL = "http://69.169.101.31:5030/";

export const ENDPOINT = "https://api-pos.eskaiy.dev/api/";
export const WEB_URL = "https://pos.eskaiy.dev/";